import request from "@/utils/request";
// 公告和规则列表
export function agreementList(params) {
    return request({
        url: "delivery/notice/index",
        method: "get",
        params,
    });
}
// 添加公告和规则列表
export function addRule(data) {
    return request({
        url: "delivery/notice/save",
        method: "post",
        data,
    });
}
// 查看
export function getRuleInfo(params) {
    return request({
        url: "delivery/notice/save",
        method: "get",
        params,
    });
}
// 删除
export function deleteRule(data) {
    return request({
        url: "delivery/notice/delete",
        method: "post",
        data,
    });
}
//平台设置
export function postConfig(data) {
    return request({
        url: "delivery/config/config",
        method: "post",
        data,
    });
}


//获取平台信息
export function getConfig(params) {
    return request({
        url: "delivery/config/config",
        method: "get",
        params,
    });
}
// 广告列表
export function adList(params) {
    return request({
        url: "delivery/advert/index",
        method: "get",
        params,
    });
}
// 添加广告
export function addAd(data) {
    return request({
        url: "delivery/advert/save",
        method: "post",
        data,
    });
}
// 查看
export function getAdInfo(params) {
    return request({
        url: "delivery/advert/save",
        method: "get",
        params,
    });
}
// 广告操作
export function operateAd(data) {
    return request({
        url: "delivery/advert/operate",
        method: "post",
        data,
    });
}
//获取阿里云Bucket--附件上传页面
export function getBucket(data) {
    return request({
        url: "delivery/config/get-bucket",
        method: "post",
        data,
    });
}
//测试发送短信
export function testTel(params) {
    return request({
        url: "delivery/message/test-tel",
        method: "get",
        params,
    });
}

export function checkAuth(data) {
    return request({
        url: "delivery/cloud/check-auth",
        method: "post",
        data,
    });
}
export function wxappList(data) {
    return request({
        url: "delivery/config/wxapp-list",
        method: "post",
        data,
    });
}
export function getAuthInfo(data) {
    return request({
        url: "delivery/cloud/get-auth-info",
        method: "post",
        data,
    });
}

export function postMerchantConfig(data) {
    return request({
      url: 'delivery/cloud/merchant-config',
      method: 'post',
      data
    })
  }
  
  export function getMerchantConfig(params) {
    return request({
      url: 'delivery/cloud/merchant-config',
      method: 'get',
      params
    })
  }